import { render, staticRenderFns } from "./OuterResearch.vue?vue&type=template&id=4878f6e7&scoped=true"
import script from "./OuterResearch.vue?vue&type=script&lang=ts"
export * from "./OuterResearch.vue?vue&type=script&lang=ts"
import style0 from "./OuterResearch.vue?vue&type=style&index=0&id=4878f6e7&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4878f6e7",
  null
  
)

export default component.exports